<template>
  <dialog-template v-model="isShownContent">
    <template slot="content">
      <h4 :class="$style.title">{{ title }}</h4>

      <div :class="$style.content">
        <slot />
      </div>

      <slot name="footer">
        <div :class="$style.button">
          <simple-button @click="$emit('click')">
            {{ $t('dialog.button.clear') }}
          </simple-button>
        </div>
      </slot>
    </template>
  </dialog-template>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';
import DialogTemplate from 'templates/old/DialogTemplate';

export default {
  name: 'InfoDialogTemplate',
  components: {
    SimpleButton,
    DialogTemplate,
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isShownContent: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownContent = val;
      },
    },
    isShownContent: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="sass" module>
  .title
    +font-type(semi-bold, 20, 30)
    color: var(---color-white)
    margin-bottom: 20px

  .content
    margin-bottom: 20px

  .button
    +flexbox
    +justify-content(center)

    +responsive(small)
      margin: 0 95px
</style>
